export const MimeTypes = ['text/plain', 'application/json', 'image/png', 'image/jpg', 'image/jpeg', 'text/html'];
